import React from 'react'
import { css } from '@emotion/core'
import { restaurantHighlightTokens } from './restaurant-highlight-config'
import type { RestaurantHighlightLegendTone } from './restaurant-highlight-config'

type Props = {
  tone: RestaurantHighlightLegendTone
  label: string
}

export const RestaurantLegendItem: React.FC<Props> = ({ tone, label }) => {
  const swatchStyleByTone =
    tone === 'new'
      ? {
          background: restaurantHighlightTokens.row.background,
          borderColor: restaurantHighlightTokens.row.legendSwatchBorderColor,
        }
      : {
          background: restaurantHighlightTokens.updated.color,
          borderColor: restaurantHighlightTokens.updated.color,
        }

  const legendItemStyle = css({
    alignItems: 'center',
    color: '#676767',
    display: 'inline-flex',
    fontSize: 12,
    fontWeight: 'bold',
    gap: 8,
    lineHeight: 1,
    whiteSpace: 'nowrap',
  })

  const legendSwatchStyle = css({
    background: swatchStyleByTone.background,
    border: `1px solid ${swatchStyleByTone.borderColor}`,
    borderRadius: 999,
    display: 'inline-block',
    flex: '0 0 auto',
    height: 12,
    width: 12,
  })

  return (
    <div css={legendItemStyle}>
      <span css={legendSwatchStyle} />
      <span>{label}</span>
    </div>
  )
}
